import axios from 'axios';
import React, { useEffect, useState } from 'react'
import { useHistory } from 'react-router';
import Content from './Content/Content';
import styles from './Toparticels.module.css'
import { v4 as uuid } from 'uuid';

const Toparticels = () => {
    const history = useHistory();
    const [data, setData] = useState([]);
    const url = process.env.REACT_APP_url;

    useEffect(() => {
        axios.get(`${url}/posts/trending`)
            .then((res) => {
                // console.log("trending", res.data.posts);
                setData(res.data.posts);
            })
            .catch((err) => {
                alert(err);
            })
    }, []);
    return (
        <div className={styles.toparticels}>
            <div className={styles.upper}>
                <div className={styles.textdescription}>
                    <h5 className={styles.heading}>Top articles</h5>
                </div>
                <div className={styles.timeline}>
                    <button className={styles.daybtn}>
                        <span style={{backgroundColor:"#e5e5e7", borderRadius:"3px", color:"rgb(41,98,255)", padding:"5px 6px"}}>1w</span>
                    </button>

                    <button className={styles.daybtn}>
                        <span>1m</span>
                    </button>

                    <button className={styles.daybtn}>
                        <span>3m</span>
                    </button>

                    <button className={styles.daybtn}>
                        <span>6m</span>
                    </button>
                </div>
            </div>
            <div className={styles.cont}>
                {data.map((post) => (
                    <Content
                        key={uuid()}
                        id={post._id}
                        user_profile={post.author.profile_pic}
                        comments={post.comments}
                        likes={post.likes}
                        heading={post.title}
                        name={post.author.name}
                    />
                ))}
            </div>
        </div>
    )
}

export default Toparticels
